import { render, staticRenderFns } from "./CardsBlock.vue?vue&type=template&id=6df493b9&scoped=true"
import script from "./CardsBlock.vue?vue&type=script&lang=js"
export * from "./CardsBlock.vue?vue&type=script&lang=js"
import style0 from "./CardsBlock.vue?vue&type=style&index=0&id=6df493b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df493b9",
  null
  
)

export default component.exports